import { Fragment, forwardRef, useEffect, useImperativeHandle, useState } from "react";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import { useAuth } from "../../../Context/AuthContext";
import { LinkProductPage } from "../../../Layout/Common/LinkProductPage";
import { isValidArray } from "../../../Layout/Common/common";
import { axiosInstance } from "../../../axios/axiosInstance";
import { showErrorSnackbar, showSuccessSnackbar } from "../../../utils/snackbarNotifications";

export const PendingOrderDetailClarification = forwardRef(({ orderId, onResolved }, ref) => {
  const [orderErrorItem, setOrderErrorItem] = useState(null);
  const [isClarification, setIsClarification] = useState(false);
  const { userId } = useAuth();

  useEffect(() => {
    if (orderId) {
      GetErrorItem(orderId);
    }
  }, [orderId]);

  useImperativeHandle(ref, () => ({ isClarification }), [isClarification]);

  const GetErrorItem = async (orderId) => {
    let hasClarification = false;
    try {
      if (userId && orderId) {
        const response = await axiosInstance.post("MyCart/GetOrderClarification", {
          userId: String(userId),
          orderId: String(orderId),
        });
        if (response.data) {
          let res = response.data;
          if (res.statusCode != -1 && isValidArray(res.data)) {
            hasClarification = true;
            res.data.forEach((item, index) => {
              setTimeout(() => {
                setOrderErrorItem((prevCards) => (prevCards ? [...prevCards, item] : [item]));
              }, index * 100);
            });
          }
        }
      }
    } catch (error) {
      console.error("GetOrderClarification failed:", error);
    } finally {
      setIsClarification(hasClarification);
      if (onResolved) onResolved(hasClarification);
    }
  };
  const handleRemoveItem = (orderCode, callback) => {
    axiosInstance
      .post("MyCart/RemoveOrderClarification", {
        sku: String(orderCode),
        userId: String(userId),
        orderId: String(orderId),
      })
      .then((response) => {
        if (response && response.data && response.data.status === 1) {
          showSuccessSnackbar("Clarification item removed successfully.");
          setOrderErrorItem((prevCards) => prevCards.filter((card) => card.orderCode != orderCode));
        } else {
          showErrorSnackbar("Failed to remove the item. Please try again.");
        }
      })
      .catch((error) => {
        showErrorSnackbar("Failed to remove the item. Please try again.");
      })
      .finally(() => {
        if (callback) callback();
      });
  };
  return (
    <Fragment>
      {orderErrorItem && (
        <div className="row">
          <div className="col-lg-12 order-clarification-info">
            <TransitionGroup>
              {orderErrorItem.map((item, index) => (
                <CSSTransition key={item.orderCode} timeout={300} classNames="card">
                  {item.style == "BLUE" ? (
                    <ErrorItemBlue item={item} index={index} handleAction={handleRemoveItem} />
                  ) : item.style == "RED" ? (
                    <ErrorItemRed item={item} index={index} handleAction={handleRemoveItem} />
                  ) : (
                    <ErrorItemOrange item={item} index={index} handleAction={handleRemoveItem} />
                  )}
                </CSSTransition>
              ))}
            </TransitionGroup>
          </div>
        </div>
      )}
    </Fragment>
  );
});

PendingOrderDetailClarification.displayName = "PendingOrderDetailClarification";

const ErrorItemRed = ({ item, index, handleAction }) => {
  const [isClicked, setIsClicked] = useState(false);
  const handleCallback = () => {
    setIsClicked(false);
  };

  const handleRemove = () => {
    setIsClicked(true);
    handleAction(item.orderCode, handleCallback);
  };
  return (
    <Fragment>
      {item && (
        <div
          className="order-clarification not-found"
          key={index}
          style={{
            opacity: isClicked ? 0.5 : 1,
          }}
        >
          <div className="order-clarification-lft">
            <h5>
              <span className="wes-alert" /> {item.clarificationMessage}
            </h5>
            {item.prod_desc && (
              <h6>
                <LinkProductPage productId={item.productId} productCode={item.orderCode} value={item.prod_desc} />
              </h6>
            )}
            <p>{`Code: ${item.orderCode} ${item.clarificationType === "ITEM_DISCONTINUED" ? "is discontinued" : "Not Found / Incorrect Code"}`}</p>
          </div>
          <div className="order-clarification-rht">
            <button type="submit" className="cc-cart-delete" onClick={handleRemove}>
              <i className="fa-regular fa-trash-can" />
            </button>
          </div>
        </div>
      )}
    </Fragment>
  );
};

const ErrorItemOrange = ({ item, index, handleAction }) => {
  const [isClicked, setIsClicked] = useState(false);

  const handleCallback = () => {
    setIsClicked(false);
  };

  const handleRemove = () => {
    setIsClicked(true);
    handleAction(item.orderCode, handleCallback);
  };

  return (
    <Fragment>
      {item && (
        <div
          className="order-clarification temporarily-unavailable"
          key={index}
          style={{
            opacity: isClicked ? 0.5 : 1,
          }}
        >
          <div className="order-clarification-lft">
            <h5>
              <span className="wes-alert" /> {item.clarificationMessage}
            </h5>
            <h6>
              <LinkProductPage productId={item.productId} productCode={item.orderCode} value={item.prod_desc} />
            </h6>
            <p>Code: {item.orderCode} is currently unavailable</p>
          </div>
          <div className="order-clarification-rht">
            <button type="submit" className="cc-cart-delete" onClick={handleRemove}>
              <i className="fa-regular fa-trash-can" />
            </button>
          </div>
        </div>
      )}
    </Fragment>
  );
};

const ErrorItemBlue = ({ item, index, handleAction }) => {
  const [isClicked, setIsClicked] = useState(false);

  const handleCallback = () => {
    setIsClicked(false);
  };

  const handleRemove = () => {
    setIsClicked(true);
    handleAction(item.orderCode, handleCallback);
  };

  return (
    <Fragment>
      {item && (
        <div
          className="order-clarification product-notAvailable"
          key={index}
          style={{
            opacity: isClicked ? 0.5 : 1,
          }}
        >
          <div className="order-clarification-lft">
            <h5>
              <span className="wes-alert" /> {item.clarificationMessage}
            </h5>
            <h6>
              <LinkProductPage productId={item.productId} productCode={item.orderCode} value={item.prod_desc} />
            </h6>
            <LinkProductPage
              productId={item.replaceItemId}
              productCode={item.replaceItemCode}
              value={` View Replacement Product : ${item.replaceItemCode}`}
            />
          </div>
          <div className="order-clarification-rht">
            <button type="submit" className="cc-cart-delete" onClick={handleRemove}>
              <i className="fa-regular fa-trash-can" />
            </button>
          </div>
        </div>
      )}
    </Fragment>
  );
};
